export interface Account {
  id: number;
  email: string;
  fullname: string;
  isActive: boolean;
}

export interface Permission {
  id: number;
  name: string;
  key: PermissionName;
}

export interface Access {
  token: string;
}

export interface Refresh {}

export interface AuthResponse {
  account: Account;
  permissions: Permission[];
  access: Access;
  refresh: Refresh;
}

export enum PermissionName {
  SECTIONS_PACKAGES_ALL = 'sections-packages.all',
  SECTION_PACKAGES_LOAD_ALL = 'section-packages-load.all',
  ENROLLMENT_MODIFICATION = 'enrollment-modification.all',
  SECTIONS_MODIFICATION = 'modification-sections.all',
  STUDENTS_POST_CLOSE = 'admin-portal.students-post-close',
  // PERMISOS DE ESTRUCTURA ACACADEMICA
  ACADEMIC_STRUCTURE = 'academic-structure.all',
  // PERMISOS DE OFERTA ACADEMICA
  ACADEMIC_OFFER_CURRICULAR_SUBJECT_ADMIN_READ = 'academic-offer.curricular-subject.administrative.read',
  ACADEMIC_OFFER_CURRICULAR_SUBJECT_ADMIN_WRITE = 'academic-offer.curricular-subject.administrative.write',
  ACADEMIC_OFFER_CURRICULAR_SUBJECT_TEACHING_READ = 'academic-offer.curricular-subject.teaching.read',
  ACADEMIC_OFFER_CURRICULAR_SUBJECT_TEACHING_WRITE = 'academic-offer.curricular-subject.teaching.write',
  ACADEMIC_OFFER_CURRICULUM = 'academic-offer.curriculum.all',
  ACADEMIC_OFFER_STUDY_PLAN = 'academic-offer.study-plans.all',
  ACADEMIC_OFFER_VACANT_OFFER = 'academic-offer.vacant-offer.all',
  ACADEMIC_OFFER_INTERIM_DEGREE = 'academic-offer.interim-degree.all',
  // PERMISOS DE ADMISION Y MATRICULA
  ADMISSIONS_AND_ENROLLMENTS_TARIFFS_AND_DISCOUNTS = 'admissions-and-enrollments.tariffs-and-discounts.all',
  ADMISSIONS_AND_ENROLLMENTS_TUITION_PROCESS = 'admissions-and-enrollments.tuition-process.all',
  ADMISSIONS_AND_ENROLLMENTS_TUITION_PROCESS_CHANGE_STATUS = 'admissions-and-enrollments.tuition-process.change-status',
  ADMISSIONS_AND_ENROLLMENTS_ADMISSION_MANAGEMENT = 'admissions-and-enrollments.admission-management.all',
  ACADEMIC_OFFER_ADMISSION_PROCESSES = 'academic-offer.admission-processes.all',
  ADMISSIONS_AND_ENROLLMENTS_DOCUMENTATION_REVIEW_PROCESS = 'admissions-and-enrollments.documentation-review-process.all',
  ADMISSIONS_AND_ENROLLMENTS_HOMOLOGATION = 'admission-enrollment.homologation.all',
  // PERMISOS DE HERRAMIENTAS DE GESTION
  MANAGEMENT_TOOLS_SURVEYS = 'management-tools.surveys.all',
  MANAGEMENT_TOOLS_PERFORMANCE_ANALYSIS = 'management-tools.performance-analysis.all',
  MANAGEMENT_TOOLS_USERS_AND_ROLES = 'management-tools.users-and-roles.all',
  MANAGEMENT_TOOLS_ANNOUNCEMENTS = 'management-tools.announcements.all',
  MANAGEMENT_TOOLS_CLASSROOMS = 'management-tools.classroom.all',
  // PERMISOS DE GRADUACIONES DE TITULOS INTERMEDIOS
  INTERIM_DEGREE_GRADUATION_PROCESS_ALL = 'interim-degree-graduation-process.all',
  // PERMISOS DE MATRÍCULA DE CONTINUIDAD
  TUITION_CONTINUITY_TARIFF_AND_TUITION = 'tuition-continuity.tariff-and-tuition.all',
  TUITION_CONTINUITY_MANAGEMENT = 'tuition-continuity.management.all',
  TUITION_CONTINUITY_DOCUMENT_REVIEW = 'tuition-continuity.document-review.all',
  TUITION_CONTINUITY_DISCOUNT_ALLOCATION = 'tuition-continuity.discount-allocation.all',
  TUITION_CONTINUITY_DISCOUNT_MANAGEMENT = 'tuition-continuity.discount-allocation-management.all',
  TUITION_CONTINUITY_CREDIT_LIQUIDATION = 'tuition-continuity.credit-liquidation.all',
  ADMISSION_CREDIT_LIQUIDATION = 'admission.credit-liquidation.all',
  // PERMISOS DE GESTIÓN DEL ESTUDIDANTE
  STUDENT_MANAGEMENT_STUDENTS_DEGREE = 'student-management.students-degree.all',
  // MÓDULOS DE SECCIONES
  SECTIONS_REGISTRATION_MASSIVE = 'sections-registration-massive.all',
  SUBJECT_SECTIONS_PERIOD_CLOSE = 'subject-sections.period-close.list',
  SUBJECT_SECTIONS_PERIOD_CLOSE_CHANGE_STATUS = 'subject-sections.period-close.manage',
  // HERRAMIENTAS DE GESTION
  REPORTS = 'reports.all',
  REPORTS_STUDENTS_WITHOUT_EMAIL = 'reports.students-without-email',
  //GESTION DEL DOCENTE
  TEACHER_MANAGEMENT_ALL = 'teacher-management.all',
  //GESTION DEL ESTUDIANTE
  STUDENT_MANAGEMENT_STUDENT_FILE = 'student-management.student-file.list',
  STUDENT_MANAGEMENT_STUDENT_FILE_MANAGE = 'student-management.student-file.manage',
  STUDENT_CURRICULUM_PROGRESS_LIST = 'studen-management.curriculum-progress.all',
  STUDENT_MANAGEMENT_ENROLLMENT_SOFT_CHANGE = 'student-management.enrollment-soft-change.all',
  STUDENT_MANAGEMENT_PETITIONS = 'student-management.petitions.all',
  STUDENT_MANAGEMENT_STUDENT_STATUS = 'student-management.student-status.list',
  STUDENT_MANAGEMENT_STUDENT_STATUS_MANAGE = 'student-management.student-status.manage',
  STUDENT_MANAGEMENT_STUDENT_STATUS_BULK_INACTIVATE_CONTINUITY = 'student-management.student-status.bulk-inactivate-continuity',
  STUDENT_MANAGEMENT_GRADUATION_PROCESS = 'student-management.graduation-process.all',
  STUDENT_MANAGEMENT_STUDENTS_REMOVAL_REQUEST = 'studen-management.students-removal-request.all',
  STUDENT_MANAGEMENT_STUDENTS_REMOVAL_REQUESTS_MANAGE = 'studen-management.students-removal-requests-manage.all',
  STUDENT_MANAGEMENT_DEGREE_PROCESS_STUDENT_MANAGE = 'student-management.degree-process-student.manage',
  //CONVALIDACIÓN INTERNA
  COURSE_VALIDATION = 'course-validation.all',
  // EDUCACIÓN CONTINUA
  CONTINUOUS_EDUCATION = 'continuous-education.all',
  //CARGA INICIAL
  ACADEMIC_RECORD = 'academic-record.all',
  //CONFIGURACION GENERAL
  SETTINGS = 'settings.all',
  //CENTRO DE PAGOS
  PAYMENT_HUB = 'payment-hub.all',
  PAYMENT_HUB_DEBTS = 'payment-hub.debts.all',
  // CUENTA CORRIENTE
  CURRENT_ACCOUNT = 'current-account.all',
  // PORTAL FINANCIERO
  FINANCIAL_PORTAL_AGREED_PAYMENTS = 'financial-portal-agreed-payments.all',
  FINANCIAL_PORTAL_PAYMENT_HISTORY = 'financial-portal-payment-history.all',
  FINANCIAL_PORTAL_REFUNDS = 'financial-portal-refunds.all',
  // GESTION DEL TUTOR
  TUTOR_MANAGEMENT_MANAGE = 'tutor-management.manage',
  // ALERTAS DE ESTUDIANTES
  STUDENT_WARNINGS_ALERTS_ALL = 'student-warnings.alerts.all',
  STUDENT_WARNINGS_CONFIG_ALL = 'student-warnings.config.all',
  STUDENT_RISK_EVALUATION_SESSION_ALL = 'student-risk-evaluation.session.all',
  STUDENT_RISK_HISTORY_ALL = 'student-risk.history.all',
  STUDENT_RISK_OBSERVATIONS_ALL = 'student-risk.observations.all',
}

export enum UserSessionEvent {
  EXPIRED = 'user-session-expired',
}
